import styled from 'styled-components';

import { H2, ImageStyled, Txt2 } from '@src/theme/common';

export const Image = styled(ImageStyled)`
  margin: 0 auto;
`;

export const LoaderWrapper = styled.div``;

export const Title = styled.h2`
  ${H2}
  text-align: center;

  margin-top: ${({ theme }) => theme.spacing(2)};
`;

export const Text = styled.p`
  ${Txt2}
  text-align: center;

  margin-top: ${({ theme }) => theme.spacing()};
`;
